import axios from './axios';

export function createDefaultCarrier(data) {
    return axios.post('/api/default-carriers', data).then(res => res.data);
}

export function getDefaultCarrierById(id) {
    return axios.get(`/api/default-carriers/${id}`).then(res => res.data);
}

export function updateDefaultCarrier(id, data) {
    return axios.put(`/api/default-carriers/${id}`, data).then(res => res.data);
}

export function deleteDefaultCarrier(id) {
    return axios.delete(`/api/default-carriers/${id}`).then(res => res.status === 204);
}

export function getDefaultCarrierPage(queryRequest, pageable = { page: 0, size: 10 }) {
    const params = {
        ...queryRequest,
        ...pageable
    };
    return axios.get('/api/default-carriers/page', { params }).then(res => res.data);
}

export function getCarrierRandomRate() {
    return axios.get('/api/default-carriers/random-rate').then(res => res.data);
}

export function updateCarrierRandomRate(noCarrierRate) {
    return axios.put('/api/default-carriers/random-rate', { noCarrierRate }).then(res => res.data);
}

export function pickRandomDefaultCarrier() {
    return axios.get('/api/default-carriers/random-pick').then(res => res.data);
}
